import tippy from "tippy.js";

function _isVisibleInDOM(element) {
  while (element) {
    const style = getComputedStyle(element);
    if (style.display === "none") return false;
    element = element.parentElement;
  }
  return true;
}

export function initializeTooltip(element) {
  tippy(element, {
    content: element.dataset.tooltip,
    placement: element.dataset.tooltipPlacement || "auto",
    popperOptions: {
      strategy: "fixed",
    },
    onShow(instance) {
      return _isVisibleInDOM(instance.reference);
    },
  });
}

export function setTooltips() {
  document.querySelectorAll("[data-tooltip]").forEach((element) => {
    initializeTooltip(element);
  });
}

window.addEventListener("DOMContentLoaded", async function () {
  setTooltips();
});

export default {
  initializeTooltip,
  setTooltips,
};
